import { MobileQuestionTooltip } from '@sbercloud/uikit-product-mobile-tooltip';
import { Typography } from '@snack-uikit/typography';
import { TEST_IDS } from '../../testIds';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function CollapseBlockHeader(_ref) {
  var title = _ref.title,
    description = _ref.description,
    tip = _ref.tip;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.headline,
      children: [/*#__PURE__*/_jsx(Typography.SansTitleM, {
        className: styles.title,
        "data-test-id": TEST_IDS.title,
        children: title
      }), tip && /*#__PURE__*/_jsx(MobileQuestionTooltip, {
        size: "s",
        tip: tip,
        triggerDataTestId: TEST_IDS.tooltip,
        tabIndex: -1
      })]
    }), description && /*#__PURE__*/_jsx(Typography.SansBodyM, {
      className: styles.subtitle,
      "data-test-id": TEST_IDS.description,
      children: description
    })]
  });
}